export default __webpack_public_path__ + "img/sapsan.d4e0c3f3.svg";